import React from 'react';
import AddressAutocomplete from './AddressAutocomplete';
import DeliveryCostDisplay from './DeliveryCostDisplay';

function AddressBlock({
  address,
  apartment,
  entrance,
  floor,
  intercom,
  apartmentAbsent,
  addressWarning,
  deliveryLoading,
  deliveryCalc,
  onAddressChange,
  onAddressBlur,
  onFieldChange,
  fieldIdPrefix,
  placeholder,
}) {
  return (
    <>
      <div className="checkout-field" id={`${fieldIdPrefix}address`}>
        <label>Адрес доставки *</label>
        <AddressAutocomplete
          value={address}
          onChange={onAddressChange}
          onBlur={onAddressBlur}
          placeholder={placeholder}
          required={true}
        />
        {addressWarning && (
          <div style={{
            marginTop: '8px',
            padding: '10px 12px',
            background: '#FFF8E1',
            border: '1px solid #FFE082',
            borderRadius: '8px',
            fontSize: '13px',
            color: '#F57F17',
            lineHeight: '1.4'
          }}>
            Дом не найден. Уточните адрес.
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 2.5fr', gap: '6px' }}>
        <div className="checkout-field" id={`${fieldIdPrefix}apartment`} style={{ marginBottom: 0 }}>
          <label style={{ fontSize: '12px' }}>Кв./Офис</label>
          <input
            type="text"
            maxLength={10}
            value={apartment}
            onChange={(e) => onFieldChange('apartment', e.target.value)}
            placeholder="№"
            disabled={apartmentAbsent}
            style={{ padding: '8px 10px', fontSize: '14px' }}
          />
        </div>
        <div className="checkout-field" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: '12px' }}>Подъезд</label>
          <input
            type="text"
            inputMode="numeric"
            maxLength={4}
            value={entrance}
            onChange={(e) => onFieldChange('entrance', e.target.value.replace(/\D/g, ''))}
            placeholder="№"
            disabled={apartmentAbsent}
            style={{ padding: '8px 10px', fontSize: '14px' }}
          />
        </div>
        <div className="checkout-field" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: '12px' }}>Этаж</label>
          <input
            type="text"
            inputMode="numeric"
            maxLength={3}
            value={floor}
            onChange={(e) => onFieldChange('floor', e.target.value.replace(/\D/g, ''))}
            placeholder="№"
            disabled={apartmentAbsent}
            style={{ padding: '8px 10px', fontSize: '14px' }}
          />
        </div>
        <div className="checkout-field" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: '12px' }}>Домофон</label>
          <input
            type="text"
            maxLength={12}
            value={intercom}
            onChange={(e) => onFieldChange('intercom', e.target.value)}
            placeholder="Код"
            disabled={apartmentAbsent}
            style={{ padding: '8px 10px', fontSize: '14px' }}
          />
        </div>
      </div>

      <div className="checkout-checkbox" style={{ marginTop: '12px' }}>
        <label>
          <input
            type="checkbox"
            checked={apartmentAbsent}
            onChange={(e) => onFieldChange('apartment_absent', e.target.checked)}
          />
          <span>Квартира/офис отсутствует</span>
        </label>
      </div>

      <DeliveryCostDisplay loading={deliveryLoading} calc={deliveryCalc} />
    </>
  );
}

export default AddressBlock;
